export default __webpack_public_path__ + "static/weather_widget-fa2c7c5b9b37ead178938c74ee91d833.webp";